// Hooks
import useApi from "./useApi"

// Utils & misc
import { API_STAGES_URL } from "../../constants/constants"

const useOffersApi = () => {
  const [requestState, payload, error, request] = useApi()

  const getOffers = () => request("GET", `${API_STAGES_URL}/v1/offers`)

  return [
    requestState,
    payload,
    error,
    {
      getOffers,
    },
  ]
}

export default useOffersApi
